jQuery(document).ready(function($) {
    
	$('.products__tags li').click(function(e) {
		e.preventDefault();
		var id = $(this).data('catid');
		var $parent = $(this).parents('.section-products');

		$('.products__tags li.active', $parent).removeClass('active');
		$(this).addClass('active');
		$('.products__cat.active', $parent).removeClass('active');
		$('#products__cat--' + id, $parent).addClass('active');
	});
 
});
